// エンジェル税制シミュレーターの注記。シミュレーターのページとエンジェル税制 LP で同じ文面を出す。
// 税制の基準時点を変えるときは、models/questions/angelTaxCalculator.ts の計算もあわせて見直す

// 所得税の計算の前提
export const CALCULATION_NOTES = [
  '令和7年12月時点の税制を基にした概算のシミュレーションとなります。',
  '所得控除は基礎控除のみで、その他控除については考慮していません。',
  '所得税額には、復興特別所得税額(2.1%)が含まれております。',
  '株式譲渡は分離課税選択で税率は15.315%(所得税および復興特別所得税)です。',
  '基礎控除の計算については、総所得金額と合計所得金額が同一である前提で行っております。',
];

// 計算結果の下に出す免責
export const DISCLAIMER =
  '本エンジェル税制税負担軽減シミュレーターは、税務申告に使用する為ではなく、仮定条件に基づく概算額の試算やそれに基づく情報提供を唯一の目的としています。実際の申告や各種株式の取得または譲渡等、プラン実行の際には、税理士等の専門家にご相談下さい。';
